// ?mock=1 URL 파라미터로 접근 시 사용되는 샘플 데이터

export const MOCK_APP = {
  id: 'mock-1',
  castingPostId: 1,
  title: '[드라마] 2026 여름 특집 단편 드라마 주·조연 모집',
  category: '드라마',
  status: '1차통과',
  company: '스튜디오 캐스타',
  companyId: 1,
  role: '주인공 (이수현)',
  date: '2026. 04. 10',
};

export const MOCK_ANNOUNCEMENT = {
  roleDesc:
    '도시에서 지친 30대 직장인이 고향 마을에 돌아오며 오래된 인연과 마주하는 이야기. 감성적이고 내면 연기가 풍부한 배우를 찾습니다.',
  period: '지원 마감: 2026-06-30',
  location: '서울 마포구',
  ageRange: '25~38세',
  height: '160cm 이상',
  skills: ['감성 연기', '사투리 (경상도)'],
  language: '한국어',
  episodeCount: '단편 드라마',
  fee: '협의 가능',
};

export const MOCK_SUBMISSION = {
  intro:
    '안녕하세요, 배우 김하진입니다.\n\n지친 현대인의 내면을 섬세하게 표현할 자신이 있습니다. 고향 마을이라는 배경이 저의 실제 경험과 맞닿아 있어 자연스러운 감정선을 가져갈 수 있을 것 같습니다.\n\n잘 부탁드립니다.',
  files: [
    {
      id: 1,
      name: '프로필_사진_김하진.jpg',
      url: 'https://picsum.photos/seed/actor/400/500',
      type: 'IMAGE',
      size: '248KB',
    },
    {
      id: 2,
      name: '이력서_2026.pdf',
      url: null,
      type: 'DOCUMENT',
      size: '124KB',
    },
  ],
  videos: [
    {
      url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      title: '자기소개 영상',
      platform: 'YouTube',
    },
  ],
};

export const MOCK_TIMELINE = [
  {
    label: '지원 완료',
    desc: '본 프로필 및 자기소개 제출',
    date: '2026.04.13',
  },
  {
    label: '1차 서류 검토',
    desc: '프로필 검토 및 필모그래피 확인 완료',
    date: '2026.04.13',
  },
  {
    label: '1차 통과',
    desc: '서류심사 통과',
    date: '2026.04.13',
  },
  {
    label: '셀프테이프 요청',
    desc: '지정 대본으로 셀프테이프 제출 필요',
    date: '2026.04.13',
    dueDate: '2026. 04. 13',
  },
];
